import { useState, type FormEvent } from "react";
import { useAuth } from "@/lib/auth";
import { supabaseConfigured } from "@/lib/supabaseClient";

export default function LoginPage() {
  const { signInWithGoogle, signInWithPassword } = useAuth();
  const [mostrarFallback, setMostrarFallback] = useState(false);
  const [email, setEmail] = useState("");
  const [senha, setSenha] = useState("");
  const [erro, setErro] = useState<string | null>(null);
  const [entrando, setEntrando] = useState(false);

  async function handleSubmit(e: FormEvent) {
    e.preventDefault();
    setEntrando(true);
    setErro(null);
    const { error } = await signInWithPassword(email, senha);
    setEntrando(false);
    if (error) setErro(error);
  }

  return (
    <div
      style={{
        minHeight: "100vh",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        padding: 24,
      }}
    >
      <div className="card" style={{ width: "min(400px, 100%)" }}>
        <h1>CRM Café Labs</h1>
        <p className="field-hint">Acesso restrito à equipe da Café Labs.</p>

        {!supabaseConfigured && (
          <p className="field-error" role="alert">
            Configuração do Supabase ausente (VITE_SUPABASE_URL /
            VITE_SUPABASE_ANON_KEY). Veja docs/backend-setup.md.
          </p>
        )}

        <button type="button" className="btn btn--primary btn--block" onClick={() => void signInWithGoogle()}>
          Entrar com Google
        </button>

        <div style={{ margin: "16px 0", textAlign: "center" }}>
          <button
            type="button"
            className="btn btn--ghost btn--sm"
            onClick={() => setMostrarFallback((v) => !v)}
            aria-expanded={mostrarFallback}
          >
            {mostrarFallback ? "Ocultar" : "Usar e-mail e senha"}
          </button>
        </div>

        {mostrarFallback && (
          <form onSubmit={handleSubmit}>
            <div className="field">
              <label htmlFor="login-email">E-mail</label>
              <input
                id="login-email"
                type="email"
                required
                autoComplete="email"
                value={email}
                onChange={(e) => setEmail(e.target.value)}
              />
            </div>
            <div className="field">
              <label htmlFor="login-senha">Senha</label>
              <input
                id="login-senha"
                type="password"
                required
                autoComplete="current-password"
                value={senha}
                onChange={(e) => setSenha(e.target.value)}
              />
            </div>
            {erro && (
              <p className="field-error" role="alert">
                {erro}
              </p>
            )}
            <button type="submit" className="btn btn--secondary btn--block" disabled={entrando}>
              {entrando ? "Entrando…" : "Entrar"}
            </button>
          </form>
        )}
      </div>
    </div>
  );
}
